/**
 * CartNotification
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('site-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this)),
    );
  }

  /**
   * open
   * @param {Boolean} hasError
   */
  open(hasError = false) {
    const errorClass = 'cart-notification--has-error';
    if (hasError) {
      this.notification.classList.add(errorClass);
    } else {
      this.notification.classList.remove(errorClass);
    }

    this.classList.add('active');
    this.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    this.addEventListener('click', this.onBodyClick);

    // trigger the cart-update event
    window.dispatchEvent(new CustomEvent('cart-notification', {
      bubbles: true,
    }));
  }

  /**
   * close
   */
  close() {
    this.classList.remove('active');
    this.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);

    // add focus to the notification trigger
    this.trigger.focus();
  }

  /**
   * renderContents
   * @param {Object} parsedState
   */
  renderContents(parsedState, isCartNotificationUpsell, trigger, is_bundle, parsedState2) {
    this.productId = parsedState.items[0].id;

    this.getSectionsToRender().forEach((section => {
      // 'not null' means the product was added from the PDP, so the upsell should not change, since it's the default
      if (section.id === 'cart-notification-upsell' && isCartNotificationUpsell !== null) return;

      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    // show the upsell
    if (this.querySelector('#cart-notification-upsell [data-product-card-wrapper]')?.innerHTML !== '') {
      this.querySelector('#cart-notification-upsell').classList.remove('hidden');
    }
    else {
      this.querySelector('#cart-notification-upsell').classList.add('hidden');
    }
    this.header?.toggleHeader(false);
    this.open();

    this.trigger = trigger;

    // When this is a bundle, re-render the cart-icon-bubble and the cart-notification-button because the bundle parent item was removed and the initial parsed state isn't accurate (product-form.js)
    if (is_bundle) {
      this.getBundleSectionsToRender().forEach((section => {

        document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState2.sections[section.id], section.selector);
      }));
    }

    // Reassign the go to card buttons to add the Tealium event also to the rendered notification button
    const goToCartButtons = document.querySelectorAll('[data-go-to-cart-button]');
    goToCartEvent(goToCartButtons);
  }

  /**
   * renderQuantityError
   * @param {String} inventoryQuantity
   */
  renderQuantityError(inventoryQuantity, trigger) {
    const errorMessageElem = this.notification.querySelector('[data-cart-notification-error-message]');
    const inventoryQty = parseInt(inventoryQuantity) || 0;

    this.trigger = trigger;

    errorMessageElem.innerText = window.cartStrings.quantityError.replace('[quantity]', inventoryQty);

    this.header?.toggleHeader(false);
    this.open(true);
  }

  /**
   * getBundleSectionsToRender
   * @returns {Array} Sections to render
   */
  getBundleSectionsToRender() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-upsell',
        selector: `#cart-notification-upsell-${this.productId}`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  /**
   * getSectionInnerHTML
   * @param {String} String that contains html
   * @param {String} selector
   * @returns
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * handleBodyClick
   * @param {Object} event
   */
  handleBodyClick(event) {
    const target = event.target;
    if (target.classList.contains('shadow')) {
      this.close();
    }
  }

  /**
   * setActiveElement
   * @param {Node} element
   */
  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
